import Image, { type ImageProps } from '@/app/components/Image';
import Motion from '@/app/components/Motion';

export interface PopStyleComparisonItemProps {
  readonly backgroundImage: {
    src: string;
  };
  readonly isInView: boolean;
  readonly maxWidthBreakpoint: number;
  readonly ringImage: ImageProps;
}

export function PopStyleComparisonItem({
  backgroundImage,
  isInView,
  maxWidthBreakpoint,
  ringImage,
}: PopStyleComparisonItemProps): JSX.Element {
  return (
    <div className="relative flex size-full items-center justify-center">
      <Motion
        animate={isInView && { opacity: 1, scale: 1 }}
        data-cy="pop_style_comparison_item_bg_image"
        className="absolute left-0 top-0 size-full"
        initial={{ opacity: 0, scale: 1.1 }}
        transition={{ delay: 0.1, duration: 1 }}
      >
        <Image
          alt=""
          className="size-full object-cover"
          fill
          src={backgroundImage.src}
        />
      </Motion>
      <Motion
        animate={isInView && { opacity: 1, scale: 1 }}
        data-cy="pop_style_comparison_item_ring_image"
        initial={{ opacity: 0, scale: 1.05 }}
        transition={{ delay: 0.3, duration: 0.5 }}
      >
        <Image
          {...ringImage}
          style={{
            height: `${(Number(ringImage.height!) / maxWidthBreakpoint) * 100}vw`,
            maxHeight: ringImage.height!,
            maxWidth: ringImage.width!,
            position: 'relative',
            width: `${(Number(ringImage.width!) / maxWidthBreakpoint) * 100}vw`,
          }}
        />
      </Motion>
    </div>
  );
}
